const mediaItems = [
  {
    title: '鬼灭之刃 柱训练篇',
    ep: '全8集',
    views: '1280万',
    img: 'https://readdy.ai/api/search-image?query=Anime%20demon%20slayer%20training%20arc%20illustration%2C%20characters%20in%20traditional%20Japanese%20training%20grounds%2C%20warm%20sunset%20lighting%2C%20bamboo%20forest%20background%2C%20soft%20and%20peaceful%20mood&width=600&height=340&seq=media-01&orientation=landscape',
  },
  {
    title: '葬送的芙莉莲',
    ep: '全28集',
    views: '2150万',
    img: 'https://readdy.ai/api/search-image?query=Fantasy%20anime%20illustration%20of%20elf%20mage%20traveling%20through%20beautiful%20landscapes%2C%20nostalgic%20atmosphere%2C%20soft%20golden%20light%2C%20adventure%20theme%2C%20gentle%20colors&width=600&height=340&seq=media-02&orientation=landscape',
  },
  {
    title: '完美世界 七神下界',
    ep: '全52集',
    views: '980万',
    img: 'https://readdy.ai/api/search-image?query=Chinese%20cultivation%20anime%20illustration%20of%20epic%20battle%20in%20ancient%20Chinese%20fantasy%20world%2C%20floating%20mountains%2C%20mystical%20energy%2C%20dramatic%20golden%20lighting&width=600&height=340&seq=media-03&orientation=landscape',
  },
  {
    title: 'Re:从零开始的异世界',
    ep: '第三季连载',
    views: '1560万',
    img: 'https://readdy.ai/api/search-image?query=Isekai%20anime%20illustration%20of%20fantasy%20world%20with%20magical%20elements%2C%20colorful%20characters%2C%20European%20medieval%20setting%2C%20dramatic%20and%20emotional%20atmosphere%2C%20vibrant%20colors&width=600&height=340&seq=media-04&orientation=landscape',
  },
  {
    title: '斗罗大陆2 绝世唐门',
    ep: '年番连载中',
    views: '3200万',
    img: 'https://readdy.ai/api/search-image?query=Chinese%203D%20anime%20illustration%20of%20martial%20arts%20school%20with%20young%20students%2C%20fantasy%20academy%20setting%2C%20bright%20and%20energetic%20atmosphere%2C%20green%20and%20gold%20color%20scheme&width=600&height=340&seq=media-05&orientation=landscape',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-xl md:text-3xl font-heading text-foreground-950">热门番剧</h2>
          <p className="mt-3 text-sm text-foreground-600">大家都在追的热门动漫番剧，看看有没有你喜欢的</p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-5 md:gap-6">
          {mediaItems.map((item) => (
            <div key={item.title} className="group rounded-2xl overflow-hidden bg-background-100 border border-background-200/70 cursor-pointer transition-all hover:-translate-y-1">
              <div className="relative w-full aspect-video overflow-hidden">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 flex items-center justify-center bg-black/10 group-hover:bg-black/20 transition-colors">
                  <div className="w-10 h-10 md:w-12 md:h-12 rounded-full bg-background-50/90 flex items-center justify-center">
                    <i className="ri-play-fill text-primary-500 text-lg md:text-xl ml-0.5"></i>
                  </div>
                </div>
                <div className="absolute bottom-2 right-2 px-2 py-0.5 rounded bg-black/60 text-[10px] text-background-50 whitespace-nowrap">
                  {item.views}次播放
                </div>
              </div>
              <div className="p-3 md:p-4">
                <h3 className="text-sm font-medium text-foreground-950 line-clamp-1">{item.title}</h3>
                <p className="mt-1 text-xs text-foreground-500">{item.ep}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}